import type { AccessCode } from '@/features/publicsite/types/community/AccessCode';
import type { ForumDetail } from '@/features/publicsite/types/community/ForumDetail';
import type { ForumPost } from '@/features/publicsite/types/community/ForumPost';
import type { ForumTopic } from '@/features/publicsite/types/community/ForumTopic';
import type { QaThread } from '@/features/publicsite/types/community/QaThread';
import type { SpaceMember } from '@/features/publicsite/types/community/SpaceMember';
import { apiDelete, apiGet, apiPost } from '@/services/api';

export const communityApi = {
  forum: (forumId: string) => apiGet<ForumDetail>(`/api/v1/forums/${forumId}`),
  topics: (forumId: string) => apiGet<ForumTopic[]>(`/api/v1/forums/${forumId}/topics`),
  createTopic: (forumId: string, title: string) =>
    apiPost(`/api/v1/forums/${forumId}/topics`, { title }),
  /** A private space's roster, owner first; members and moderators only. */
  members: (forumId: string) => apiGet<SpaceMember[]>(`/api/v1/forums/${forumId}/members`),
  /** The code that lets an account join the space; its owner only. */
  accessCode: (forumId: string) => apiGet<AccessCode>(`/api/v1/forums/${forumId}/access-code`),
  /** A new code; the old one no longer joins. */
  renewAccessCode: (forumId: string) =>
    apiPost<AccessCode>(`/api/v1/forums/${forumId}/access-code/renew`),
  leave: (forumId: string) => apiDelete(`/api/v1/forums/${forumId}/members/me`),
  removeMember: (forumId: string, userId: string) =>
    apiDelete(`/api/v1/forums/${forumId}/members/${userId}`),
  posts: (topicId: string) => apiGet<ForumPost[]>(`/api/v1/topics/${topicId}/posts`),
  pendingPosts: (topicId: string) => apiGet<ForumPost[]>(`/api/v1/topics/${topicId}/posts/pending`),
  reply: (topicId: string, body: string) => apiPost(`/api/v1/topics/${topicId}/posts`, { body }),
  moderatePost: (postId: string, approve: boolean) =>
    apiPost(`/api/v1/posts/${postId}/${approve ? 'approve' : 'reject'}`),
  qaThread: (sessionId: string) => apiGet<QaThread>(`/api/v1/public/qa/${sessionId}`),
  ask: (sessionId: string, question: string) =>
    apiPost(`/api/v1/qa/${sessionId}/questions`, { question }),
  answer: (questionId: string, answer: string) =>
    apiPost(`/api/v1/qa/questions/${questionId}/answer`, { answer }),
};
